import { render, staticRenderFns } from "./HomeProductTab.vue?vue&type=template&id=68049632&"
import script from "./HomeProductTab.vue?vue&type=script&lang=js&"
export * from "./HomeProductTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports